<template>
    <v-checkbox
        :input-value="value"
        :disabled="disabled"
        :on-icon="customIcons ? 'mdi-checkbox-marked-outline' : '$checkboxOn'"
        :off-icon="customIcons ? 'mdi-checkbox-blank-outline' : '$checkboxOff'"
        :label="label"
        :error-messages="errorMessages"
        :hide-details="!errorMessages"
        class="mt-0"
        dense
        color="n4"
        @change="handleChange"
        @input="handleInput"
    >
        <template slot="append">
            <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                    <v-icon
                        class="mt-1"
                        small
                        v-on="on"
                    >
                        mdi-information-outline
                    </v-icon>
                </template>
                <span>{{ title }}</span>
            </v-tooltip>
        </template>
    </v-checkbox>
</template>

<script>
export default {
    name: "SecondaryCheckbox",
    props: {
        value: {
            type: [Boolean, Number],
            default: false
        },
        label: {
            type: String,
            default: ""
        },
        errorMessages: {
            type: Array,
            default: () => []
        },
        title: {
            type: String,
            default: ''
        },
        customIcons: {
            type: Boolean,
            default: true
        },
        color: {
            type: String,
            default: 'grey'
        },
        disabled: {
            type: Boolean,
            default: false
        }
    },
    setup(props, ctx) {
        const handleChange = function(){
            ctx.emit('change')
        }

        const handleInput = function () {
            ctx.emit('input')
        }

        return {
            handleChange,
            handleInput
        }
    }
}
</script>
